import { store } from '@/store';
import router from '@/router';
const MainHeader = () => import('@/components/MainHeader');
const ApplicantForm = () => import('@/views/common/insure/corporation/ApplicantForm');
const AssuredForm = () => import('@/views/common/insure/corporation/AssuredForm');
const Review = () => import('@/views/common/insure/corporation/Review');

/**
 * 保費試算流程
 */
export default [
    {
        path: '/:type(car|motor)/insure/corporation/',
        redirect: '/:type(car|motor)/insure/corporation/applicant-form'
    },
    {
        // step-1 要保人資料
        path: '/:type(car|motor)/insure/corporation/applicant-form',
        name: 'CarInsureCorporationApplicantForm',
        components: {
            default: ApplicantForm,
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {

            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            // 沒有試算過的踢回首頁
            if (!store.state.policy.calculatedAt) return next(`/${router.currentRoute.value.params.type}`);

            next();
        }
    },
    {
        // step-2 被保險人資料
        path: '/:type(car|motor)/insure/corporation/assured-form',
        name: 'CarInsureCorporationAssuredForm',
        components: {
            default: AssuredForm,
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {

            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            // 沒有試算過的踢回首頁
            if (!store.state.policy.calculatedAt) return next(`/${router.currentRoute.value.params.type}`);

            next();
        }
    },
    {
        // step-2 確認要保資料
        path: '/:type(car|motor)/insure/corporation/review',
        name: 'CarInsureCorporationReview',
        components: {
            default: Review,
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/loggedIn']) {
                store.commit('nav/setAll', {to: to, from: from, clear: true});
                return next({name: 'Login' });
            }

            // 如果被保險人暨要保人資料沒填完，踢回去資寫
            if (!store.getters['estimate/isApplicantDataFilledOut']) {
                return next({name: 'CarInsureCorporationApplicantForm'});
            }

            next();
        }
    },
];